import { render } from "./App.vue?vue&type=template&id=d83ca30e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d83ca30e&lang=css"
script.render = render

export default script